import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import InfoToolTip from '@components/InfoToolTip'

import { useAgencyForm } from '@hooks/useAgency'

interface AgencyDetailsProps {
  agencyFormPayload: ReturnType<typeof useAgencyForm>,
}

const AgencyDetails = (props: AgencyDetailsProps) => {
  const {
    agencyFormPayload: {
      entityState: {
        business_name,
        business_number,
        email,
        fax,
        license_number,
        phone,
        short_name,
        title,
        website,
      },
      errors,
      handlers,
    },
  } = props

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <InfoToolTip>
          Your agency name and short name will be used in various marketing materials.
          <br />
          <br />
          Legal information is used in system invoicing and, in the case of some accounts, on marketing artworks.
        </InfoToolTip>
      )}
      title="Agency Details"
    >
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input
              name="title"
              value={title}
              type="text"
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Short Name" marginTop={['large', 0]}>
            <input
              name="short_name"
              value={short_name}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Field label="Business Name" marginTop="large">
          <input
            name="business_name"
            value={business_name}
            type="text"
            {...handlers}
          />
        </Form.Field>

        <Form.Row marginTop="large">
          <Form.Field label="ABN or NZBN">
            <input
              name="business_number"
              value={business_number}
              type="text"
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="License Number" marginTop={['large', 0]}>
            <input
              name="license_number"
              type="text"
              value={license_number}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="* Agency Email" errorMessage={errors.email}>
            <input
              name="email"
              type="email"
              value={email}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="* Office Phone" errorMessage={errors.phone} marginTop={['large', 0]}>
            <input
              name="phone"
              type="text"
              value={phone}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="* Agency URL" errorMessage={errors.website}>
            <input
              name="website"
              type="text"
              value={website}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Office fax" marginTop={['large', 0]}>
            <input
              name="fax"
              type="text"
              value={fax}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default AgencyDetails
